//
//
//
//
//

export default {
  props: {
    num: {
      type: Number, default: 0
    },
    burstMoneyTrend: {
      type: [String, Array], default: ''
    },
    type: {
      type: Number, default: 0
    }
  },
  data () {
    return {
      lineCharts: null // 图表实例
    }
  },
  watch: {
    burstMoneyTrend (newVal) {
      this.getLineCharts()
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getLineCharts()
    })
  },
  beforeDestroy () {
    this.lineCharts?.clear() // 清空当前实例
    this.lineCharts?.dispose() // 销毁图表
    this.lineCharts = null
  },
  methods: {
    getLineCharts () {
      let data
      if (this.type == 0) {
        data = this.burstMoneyTrend.split(',')
      } else {
        data = this.burstMoneyTrend
      }
      const xData = []
      data.forEach((item) => {
        xData.push(0)
      })
      if (!this.lineCharts) this.lineCharts = this.$echarts.init(document.getElementsByClassName('line-charts')[this.num])
      const option = {
        backgroundColor: 'transparent',
        tooltip: {
          confine: true,
          trigger: 'axis',
          backgroundColor: 'rgba(0,0,0,.7)',
          textStyle: {
            color: '#fff'
          },
          axisPointer: {
            lineStyle: {
              width: 0
            }
          },
          formatter (params) {
            return `<div class="tooltip-box">${params[0].value}</div>`
          }
        },
        grid: {
          top: '40%',
          left: '2%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          data: xData
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          }
        },
        series: [
          {
            type: 'line',
            smooth: true,
            symbol: 'circle',
            showSymbol: false,
            symbolSize: 5,
            itemStyle: {
              lineStyle: {
                color: '#5C8AE5',
                width: 2
              }
            },
            data
          }
        ]
      }
      this.lineCharts.clear()
      this.lineCharts.setOption(option, true)
    }
  }
}
